import React, { useContext } from "react";
import { Controller } from "react-hook-form";
import { IonLabel, IonItem, IonSelect, IonSelectOption } from "@ionic/react";
import RestrictedContext from "../util/RestrictedContext";
import { FormattedMessage } from "react-intl";
import SkeltonItemContent from "./SkeltonItemContent";
import { useIntl } from "react-intl";

const PredefinedSelectItem = (props) => {
  const {
    name,
    control,
    rules,
    label,
    disabled,
    type,
    reasonNotApproved,
    duration,
    data,
    loading,
  } = props;
  const intl = useIntl();
  const restricted = useContext(RestrictedContext);
  const options = {
    cssClass: "select-interface",
  };
  const reasonNotApprovedData = [
    {
      value: 1,
      name: (
        <FormattedMessage id="app.mobile.dataSelect.houseVisit.hospitalization" />
      ),
    },
    {
      value: 2,
      name: <FormattedMessage id="app.mobile.dataSelect.houseVisit.absence" />,
    },
    {
      value: 3,
      name: (
        <FormattedMessage id="app.mobile.dataSelect.houseVisit.dayCenter" />
      ),
    },
    {
      value: 4,
      name: (
        <FormattedMessage id="app.mobile.dataSelect.houseVisit.householdMemberAbsence" />
      ),
    },
    {
      value: 5,
      name: (
        <FormattedMessage id="app.mobile.dataSelect.houseVisit.refusaToOpen" />
      ),
    },
    {
      value: 6,
      name: (
        <FormattedMessage id="app.mobile.dataSelect.houseVisit.refuseToCooperate" />
      ),
    },
    {
      value: 7,
      name: (
        <FormattedMessage id="app.mobile.dataSelect.houseVisit.InaccessiblePlace" />
      ),
    },
    {
      value: 8,
      name: (
        <FormattedMessage id="app.mobile.dataSelect.houseVisit.otherReason" />
      ),
    },
    {
      value: 9,
      name: (
        <FormattedMessage id="app.mobile.dataSelect.houseVisit.noObligationToVisit" />
      ),
    },
    {
      value: 10,
      name: (
        <FormattedMessage id="app.mobile.dataSelect.houseVisit.completionOfHours" />
      ),
    },
  ];

  const durationData = [
    {
      value: 0,
      name: <FormattedMessage id="app.mobile.dataSelect.duration.0minutes" />,
    },
    {
      value: 5,
      name: <FormattedMessage id="app.mobile.dataSelect.duration.5minutes" />,
    },
    {
      value: 10,
      name: <FormattedMessage id="app.mobile.dataSelect.duration.10minutes" />,
    },
    {
      value: 15,
      name: <FormattedMessage id="app.mobile.dataSelect.duration.15minutes" />,
    },
    {
      value: 20,
      name: <FormattedMessage id="app.mobile.dataSelect.duration.20minutes" />,
    },
    {
      value: 25,
      name: <FormattedMessage id="app.mobile.dataSelect.duration.25minutes" />,
    },
    {
      value: 30,
      name: <FormattedMessage id="app.mobile.dataSelect.duration.30minutes" />,
    },
    {
      value: 35,
      name: <FormattedMessage id="app.mobile.dataSelect.duration.35minutes" />,
    },
    {
      value: 40,
      name: <FormattedMessage id="app.mobile.dataSelect.duration.40minutes" />,
    },
    {
      value: 45,
      name: <FormattedMessage id="app.mobile.dataSelect.duration.45minutes" />,
    },
    {
      value: 50,
      name: <FormattedMessage id="app.mobile.dataSelect.duration.50minutes" />,
    },
    {
      value: 55,
      name: <FormattedMessage id="app.mobile.dataSelect.duration.55minutes" />,
    },
    {
      value: 60,
      name: <FormattedMessage id="app.mobile.dataSelect.duration.60minutes" />,
    },
  ];

  let selectData = data;
  if (reasonNotApproved) {
    selectData = reasonNotApprovedData;
  } else if (duration) {
    selectData = durationData;
  }

  return loading ? (
    <IonItem>
      <SkeltonItemContent />
    </IonItem>
  ) : (
    <IonItem>
      <IonLabel position="floating">{label}</IonLabel>
      <Controller
        control={control}
        rules={rules}
        render={({ field }) => {
          const { onChange, onBlur, value } = field;
          return (
            <IonSelect
              value={value}
              interfaceOptions={options}
              disabled={disabled || !restricted["hasWritePermission"]}
              onIonChange={(e) => onChange(e.detail.value)}
              onBlur={onBlur}
              type={type}
              okText={intl.formatMessage({
                id: "app.mobile.actions.approve",
              })}
              cancelText={intl.formatMessage({
                id: "app.mobile.actions.cancel",
              })}
            >
              {selectData.map((option) => (
                <IonSelectOption key={option.value} value={option.value}>
                  {option.name}
                </IonSelectOption>
              ))}
            </IonSelect>
          );
        }}
        name={name}
      />
    </IonItem>
  );
};

export default PredefinedSelectItem;
